import { default as SearchComponent } from '../default';
import styles from './styles.scss';
import cn from 'classnames';
import Icon from 'components/Shared/Icon';

interface OwnProps {
  className?: string;
}

export const Search = ({ className }: OwnProps) => (
  <SearchComponent
    buttonComponent={
      <button>
        <Icon icon="icon-search-uw" />
      </button>
    }
    className={cn(styles.search, className)}
  />
);
